/**
 * Deployment stage, read from `REACT_APP_RUN_MODE`. Selects the Cognito stack in
 * `@realtyfeed/auth` and gates stage-only behaviour.
 *
 * The string values are fixed by the deployed `.env` files and the backend - do
 * not "tidy" `staging` into `stage` or `devTest` into `dev-test`.
 */
export const RUN_MODE = {
  DevTest: 'devTest',
  Dev: 'dev',
  Staging: 'staging',
  Prod: 'prod',
} as const;

export type RunMode = (typeof RUN_MODE)[keyof typeof RUN_MODE];

export const isProductionLike = (mode: string | undefined): boolean =>
  mode === RUN_MODE.Prod || mode === RUN_MODE.Staging;
